/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { Button, Card, CardContent, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { deleteParameterByID, getParameter } from "utils/superAdminApi";
import LoadingModal from "../../components/LoadingModel/loadingModal";



function Parameters() {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    sortingType: "",
    sortingField: "",
    parameterStatus: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['parameterName', 'parameterCode', 'parameterStatus'],
  });


  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch()
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getRight();
  }, []);

  async function getRight() {
    let right = await getScreenRight("Parameter Lists")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }

  const handleDeleteDialogeClick = async (value) => {
    values._id = value;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteRow();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteRow = async () => {
    deleteParameterByID(values, (data) => {
      if (data.Result_Status) fetchParameter();
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)

  };

  useEffect(() => {
    fetchParameter()
  }, [customerReload, values.parameterStatus]);


  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchParameter();
    }
  }, [values.filterValues]);

  const fetchParameter = async () => {
    getParameter(values, (data) => {
      if (data.Result_Status) {

        setTotalRows(data.Result_Output.totalDocs)
        setRows(data.Result_Output.docs);
      } else {
        setTotalRows(0)
        setRows([]);
      }
    }, dispatch)

  }

  const handlePageChange = page => {
    values.page = page;
    setCustomerReload(!customerReload)
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setCustomerReload(!customerReload)
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    setCustomerReload(!customerReload)
  };

  const parameterCol = [
    {
      name: "Parameter Name",
      selector: row => row.parameterName,
      sortable: true,
      sortField: 'parameterName',
      left: true,
    },
    {
      name: "Parameter Code",
      selector: row => row.parameterCode,
      sortable: true,
      sortField: 'parameterCode',
      center: true,
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "12px" }}>Status</p>,
      selector: row => row.parameterStatus,
      sortable: true,
      sortField: 'parameterStatus',
      center: true,
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>

          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>

            <Grid item style={{ marginLeft: "-20px" }}>
              <Link to=
                {`/parameter/editParameter/${row._id}`}

              >
                <TimelineItem
                  color="success"
                  icon="edit"
                  title="Edit"
                />
              </Link>
            </Grid>

            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>



          </Grid>


        </>
      ),
    },


  ]


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Parameter Lists" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.parameterStatus}
                  onChange={(e) => setValues({ ...values, parameterStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={((e) => setValues({ ...values, filterValues: e.target.value }))}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchParameter();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchParameter}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <Link to={"/parameter/addParameter"}>
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"}
                  style={{ height: "44.11px", width: "99px" }}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              columns={parameterCol}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}

            />
          </CardContent>
        </Card>
      </div >

      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );

}

export default Parameters;
